<app-head></app-head>

<div class="main-container">
  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Bienvenue <span
            style="color: #4c7191">{{ user?.username }}</span></h2>
  </div>


  <div class="metrics-container">
    <div class="value-container" (click)="routeTo('stocks/low-stock')">
      <span class="metric-title"> Articles en faible stock</span>
      <span class="metric-value">{{lowStockMetric}}</span>
    </div>
    <div class="value-container" (click)="routeTo('stocks/out-stock')">
      <span class="metric-title"> Articles en rupture stock</span>
      <span class="metric-value">{{outStockMetric}}</span>
    </div>
    <div class="value-container" (click)="routeTo('stocks/in-stock')">
      <span class="metric-title"> Articles en stock</span>
      <span class="metric-value">{{ inStockMetric }}</span>
    </div>
  </div>

</div>
